import { useSyncExternalStore } from "react";
import { getPlanningWriteActivityMessage, subscribePlanningLiveSyncActivity } from "../utils/planningMutationActivity.js";

export default function usePlanningWriteActivity() {
  return useSyncExternalStore(subscribePlanningLiveSyncActivity, getPlanningWriteActivityMessage, () => "");
}
